import { type ApiClient } from 'utils/requests.utils'
import { Response } from 'types/responses'

const BASE_URL = '/shop'

interface Token {
  paypalIdToken: string
}

export const createProviderDataApi = ({ GET }: ApiClient) => ({
  fetchPaypalIdToken: (shopName: string, provider: string, data: any) =>
    GET<Response<Token>>(`${BASE_URL}/${shopName}/paypal_id_tokens/${provider}`, data),
})
